/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type DocumentDateConfidence =
    (typeof DocumentDateConfidence)[keyof typeof DocumentDateConfidence];

export const DocumentDateConfidence = {
    Low: 0,
    Medium: 1,
    High: 2,
} as const;
